export class TransactionBatchesRequest {
    kioskId: string;
    tenantId: string;
    endDate: string;
    startDate: string;
}